// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { equipmentTypeId } from './EquipmentType';
import { operatorId } from './Operator';
import { cleaningProcedureId } from './CleaningProcedure';
import { deviceModelId } from './DeviceModel';
import { brewcontrolWiringLineageId } from './BrewcontrolWiringLineage';
import { z } from 'zod';
export const equipmentModelId = (z.number());
export const equipmentModel = z.object({
    id: equipmentModelId,
    equipment_type_id: equipmentTypeId,
    name: z.string(),
    manufacturer: z.string().nullable(),
    model_number: z.string().nullable(),
    description: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    data_file_parser: z.string().nullable(),
    pre_cleaning_procedure_id: cleaningProcedureId.nullable(),
    post_cleaning_procedure_id: cleaningProcedureId.nullable(),
    device_model_id: deviceModelId.nullable(),
    brewcontrol_wiring_lineage_id: brewcontrolWiringLineageId.nullable(),
});
export const equipmentModelInitializer = z.object({
    id: equipmentModelId.optional(),
    equipment_type_id: equipmentTypeId,
    name: z.string(),
    manufacturer: z.string().optional().nullable(),
    model_number: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    data_file_parser: z.string().optional().nullable(),
    pre_cleaning_procedure_id: cleaningProcedureId.optional().nullable(),
    post_cleaning_procedure_id: cleaningProcedureId.optional().nullable(),
    device_model_id: deviceModelId.optional().nullable(),
    brewcontrol_wiring_lineage_id: brewcontrolWiringLineageId.optional().nullable(),
});
export const equipmentModelMutator = z.object({
    id: equipmentModelId.optional(),
    equipment_type_id: equipmentTypeId.optional(),
    name: z.string().optional(),
    manufacturer: z.string().optional().nullable(),
    model_number: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    data_file_parser: z.string().optional().nullable(),
    pre_cleaning_procedure_id: cleaningProcedureId.optional().nullable(),
    post_cleaning_procedure_id: cleaningProcedureId.optional().nullable(),
    device_model_id: deviceModelId.optional().nullable(),
    brewcontrol_wiring_lineage_id: brewcontrolWiringLineageId.optional().nullable(),
});
//# sourceMappingURL=EquipmentModel.js.map